export const ARIA_LABELS = {
  USER_SETTINGS: 'User Settings',
};
